import type { ReactElement, ReactNode } from "react"
import { Children, isValidElement } from "react"
import type Theme from "@onestore/hel/dist/typings/theme"
import type { UdsColor } from "@gatsby-plugin-generic-page/helpers/helTypographyToUds"
import { helTypographyToUdsProps } from "@gatsby-plugin-generic-page/helpers/helTypographyToUds"
import { Text } from "@ionos-web-design-system/react"
import isEmpty from "~/lib/isEmpty"

interface Props {
  children: ReactNode
  typography: Theme.Typography
  pushSpace: number
  color?: UdsColor
}
const pushSpaceToClass: Record<number, string> = {
  1: "mb-2",
  2: "mb-4",
  3: "mb-6",
  4: "mb-8",
}

function Paragraph({
  children,
  typography,
  pushSpace,
  color,
}: Props): ReactElement {
  const childrenArray = Children.toArray(children)
  const textChild = childrenArray.find(
    (child) =>
      typeof child === "string" ||
      (isValidElement(child) &&
        !isEmpty(child.props) &&
        (child.props as Record<string, unknown>).hasOwnProperty("typography"))
  )

  if (isEmpty(textChild)) {
    return <>{children}</>
  }

  return (
    <Text
      asChild
      {...helTypographyToUdsProps(typography)}
      className={pushSpaceToClass[pushSpace] ?? "mb-2"}
      color={color}
    >
      <p>{children}</p>
    </Text>
  )
}

export default Paragraph
